export var Quality;
(function (Quality) {
    Quality["SD"] = "sd";
    Quality["HQ"] = "hq";
    Quality["HD"] = "hd";
    Quality["FullHD"] = "fullhd";
})(Quality || (Quality = {}));
//# sourceMappingURL=Quality.js.map